import { render, staticRenderFns } from "./CommUsers.vue?vue&type=template&id=508a7010&scoped=true"
import script from "./CommUsers.vue?vue&type=script&lang=js"
export * from "./CommUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508a7010",
  null
  
)

export default component.exports